// EditarUsuario.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import BasicLayout from "../../layauots/BasicLayout";
import { Card } from "react-bootstrap";
import MDBox from "../../controls/MDBox";
import MDTypography from "../../controls/MDTypography";
import MDInput from "../../controls/MDInput";
import { Save } from "react-bootstrap-icons";
import { ExitToApp } from "@mui/icons-material";
import MDButton from "../../controls/MDButton";
import { Alert, AlertTitle, Autocomplete, Checkbox, TextField } from "@mui/material";
import bgImage from "../../../assets/images/bg-sign-up-cover.jpeg";
import { getData, postData } from "../../Utils/Http/api";
import { fetchPerfilActual } from "../../Utils/PerfilActual";
import requestVacios from "../../Utils/Interfaces/requestVacios";

// Disparador Automático de Gestiones (plan 3.2b).
const MODALIDADES = [
    { value: 0, label: "Voluntario", detalle: "Pide un caso cuando quiere; no está obligado." },
    { value: 1, label: "Obligatorio", detalle: "Trabaja siempre con el caso que el sistema le asigna." },
    { value: 2, label: "Mixto", detalle: "Es Obligatorio los días marcados y Voluntario el resto." },
];
// Días de la semana en formato ISO: 1 = lunes ... 7 = domingo.
const DIAS_SEMANA = [
    { value: 1, label: "Lun" },
    { value: 2, label: "Mar" },
    { value: 3, label: "Mié" },
    { value: 4, label: "Jue" },
    { value: 5, label: "Vie" },
    { value: 6, label: "Sáb" },
    { value: 7, label: "Dom" },
];


const UsuarioEdit = () => {
    const { id } = useParams(); // Obtener el parámetro de la URL (el ID del Usuario a editar)
    const [Usuario, setUsuario] = useState(null);
    const [activo, setActivo] = useState(false);
    const [nombre, setNombre] = useState("");
    const [email, setEmail] = useState("");
    const [telefono, setTelefono] = useState("");
    const [idPerfil, setIdPerfil] = useState("");
    const [elementsPerfil, setElementsPerfil] = useState(false);
    const [selectedValuePerfil, setSelectedValuePerfil] = useState(null);
    // Disparador Automático de Gestiones
    const [modalidadGestion, setModalidadGestion] = useState(0);
    const [gestionesMinimasDia, setGestionesMinimasDia] = useState("");
    const [diasObligatorios, setDiasObligatorios] = useState([]);
    const [gestionesMinimasPerfil, setGestionesMinimasPerfil] = useState(0);
    const [puedeGestionarDisparador, setPuedeGestionarDisparador] = useState(false);

    const [nombreboton, setnombreboton] = useState("Cancelar");
    const [mensaje, setMensaje] = useState("");
    const history = useNavigate();
    const [grabando, setGrabando] = useState(false);
    const [exito, setExito] = useState(false);
    const handleVolver = () => {
        history("/UsuarioVolver"); // Cambia '/ruta-de-listado' por la ruta real de tu listado de datos
    };


    useEffect(() => {

        // Aquí realizas la llamada a tu API para obtener el Usuario específico por su ID
        const GetUsuario = async () => {
            try {
                const reqUsuario = {
                    idUsuario: id
                };

                const data = await getData(`UsuarioGetByID/${id}`);
                setUsuario(data.value);
                setIdPerfil(data.value.idPerfil);
                setNombre(data.value.nombre);
                setActivo(data.value.activo);
                setEmail(data.value.email);
                setTelefono(data.value.telefono);
                setModalidadGestion(data.value.modalidadGestion ?? 0);
                setGestionesMinimasDia(data.value.gestionesMinimasDia ? String(data.value.gestionesMinimasDia) : "");

                const dias = await getData(`UsuarioModalidadDiasListar/${id}`);
                setDiasObligatorios(dias?.value ?? []);

            } catch (error) {
                console.error("Error:", error);
            }
        };
        GetUsuario();
    }, [id]);

    // Solo los perfiles con la casilla "Puede definir la modalidad de gestión" pueden cambiar estos datos.
    useEffect(() => {
        fetchPerfilActual().then((perfil) => setPuedeGestionarDisparador(!!perfil.puedeGestionarDisparador));
    }, []);

    // Las gestiones mínimas del perfil elegido: son las que vale si el usuario no tiene las suyas.
    useEffect(() => {
        if (!idPerfil) return;
        getData(`PerfilGet/${idPerfil}`)
            .then((res) => setGestionesMinimasPerfil(res?.value?.gestionesMinimasDia ?? 0))
            .catch(() => setGestionesMinimasPerfil(0));
    }, [idPerfil]);

    const handleToggleDia = (dia) => {
        setDiasObligatorios((prev) => (prev.includes(dia) ? prev.filter((d) => d !== dia) : [...prev, dia].sort((a, b) => a - b)));
    };



    useEffect(() => {
        const GetPerfil = async () => {
            if (Usuario) {

                const response = await getData("PerfilListar");

                setElementsPerfil(response.value);


                const defaultValueId = idPerfil;
                const defaultValue = response.value.find(item => item.idPerfil === defaultValueId);
                setSelectedValuePerfil(defaultValue);

            }
        }; GetPerfil();
    }, [Usuario]);

    const handleAutocompletePerfilChange = (event, value) => {
        setSelectedValuePerfil(value);
        setIdPerfil(value.idPerfil);
    };

    const handleSubmit = async (event) => {
        try {

            setMensaje("");
            if (nombre === '') {
                setMensaje("El campo nombre es obligatorio");
                setExito(false);
                return;
            }

            setGrabando(true); // Inicia la grabación
            setnombreboton("Volver");
            setExito(true);
            setMensaje('');

            const reqUsuario = {
                idUsuario: id,
                nombre: nombre,
                telefono: telefono,
                idPerfil: idPerfil,
                activo: activo
            };
            // Los datos del Disparador solo se envían si el perfil de quien edita puede cambiarlos (y el gestor testigo no los tiene).
            if (puedeGestionarDisparador && !Usuario.esTestigo) {
                reqUsuario.modalidadGestion = modalidadGestion;
                reqUsuario.gestionesMinimasDia = Math.max(parseInt(gestionesMinimasDia, 10) || 0, 0);
                reqUsuario.diasObligatorios = diasObligatorios;
            }
            const res = await postData("UsuarioUpdate", reqUsuario);

            if (res.isSuccess) {
                // Manejar respuesta exitosa
                setMensaje("¡Datos actualizados exitosamente!");
            } else {
                // Manejar errores si la respuesta no es exitosa
                setMensaje(res.error);
                setGrabando(false); // Inicia la grabación
                setnombreboton("Cancelar");
                setExito(false);
            }
        } catch (error) {
            setMensaje("Error en la solicitud:", error);
            setGrabando(false); // Inicia la grabación
            setExito(false);
            setnombreboton("Cancelar");
            console.log("Error en la solicitud:" + error);
        }
    };

    if (!Usuario) {
        return <BasicLayout image={bgImage}>
            <Card style={{ width: "157%" }}>
                <MDBox
                    variant="gradient"
                    bgColor="warning"
                    borderRadius="lg"
                    coloredShadow="primary"
                    mx={2}
                    mt={-3}
                    p={3}
                    mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        Cargando Usuarios...
                    </MDTypography>
                </MDBox>

            </Card>
        </BasicLayout>
    }

    return (
        <BasicLayout image={bgImage}>
            <Card>
                <MDBox
                    variant="gradient"
                    bgColor="warning"
                    borderRadius="lg"
                    coloredShadow="success"
                    mx={2}
                    mt={-3}
                    p={3}
                    mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        Editar Usuario
                    </MDTypography>
                    <MDTypography display="block" variant="button" color="white" my={1}>
                        Un Usuario es la entidad que interactua con el sistema, segun el perfil que tenga
                    </MDTypography>
                </MDBox>
                <MDBox pt={4} pb={3} px={3}>
                    <MDBox component="form" role="form">

                        <MDBox mb={2}>
                            <MDInput
                                type="text"
                                name="nombre"
                                required
                                label="Nombre"
                                variant="standard"
                                value={nombre}
                                onChange={(e) => setNombre(e.target.value)}
                                fullWidth
                            />
                        </MDBox>
                        {Usuario.esTestigo ? (
                            <MDBox mb={2}>
                                <Alert severity="info">
                                    Gestor testigo: no inicia sesión, por eso no tiene correo, teléfono ni perfil.
                                    Solo se puede cambiar su nombre y si está activo.
                                </Alert>
                            </MDBox>
                        ) : (
                            <>
                                <MDBox mb={1} style={{ display: "flex", gap: "16px" }}>
                                    <MDInput
                                        type="text"
                                        name="email"
                                        required
                                        label="Email"
                                        disabled={true}
                                        variant="standard"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        fullWidth
                                    />

                                    <MDInput
                                        type="text"
                                        name="telefono"
                                        required
                                        label="Telefono"
                                        variant="standard"
                                        value={telefono}
                                        onChange={(e) => setTelefono(e.target.value)}
                                        fullWidth
                                    />
                                </MDBox>
                                <MDBox mb={2} >
                                    <Autocomplete
                                        onChange={handleAutocompletePerfilChange}
                                        options={elementsPerfil}
                                        value={selectedValuePerfil || null}
                                        getOptionLabel={(option) => option.nombre || ''}
                                        getOptionDisabled={(option) => option.activo === false}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Seleccione Perfil"
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </MDBox>
                            </>
                        )}

                        <MDBox mb={2}>

                            <Checkbox name="activo"
                                onChange={(e) => setActivo(e.target.checked)}
                                checked={activo}

                            />
                            <MDTypography
                                variant="button"
                                fontWeight="regular"
                                color="text"
                                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                            >
                                &nbsp;&nbsp;Activo
                            </MDTypography>
                        </MDBox>

                        {!Usuario.esTestigo && (
                            <MDBox mb={2}>
                                <MDTypography variant="h6" fontWeight="medium" mb={1}>
                                    Gestión de casos (Disparador Automático)
                                </MDTypography>
                                {puedeGestionarDisparador ? (
                                    <>
                                        <Autocomplete
                                            options={MODALIDADES}
                                            value={MODALIDADES.find((m) => m.value === modalidadGestion) || null}
                                            onChange={(event, value) => setModalidadGestion(value ? value.value : 0)}
                                            getOptionLabel={(option) => option.label || ''}
                                            isOptionEqualToValue={(option, value) => option.value === value.value}
                                            disableClearable
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Seleccione Modalidad"
                                                    variant="outlined"
                                                    helperText={MODALIDADES.find((m) => m.value === modalidadGestion)?.detalle}
                                                />
                                            )}
                                        />
                                        {modalidadGestion === 2 && (
                                            <MDBox mt={1}>
                                                <MDTypography variant="button" fontWeight="regular" color="text">
                                                    Días en que es Obligatorio
                                                </MDTypography>
                                                <MDBox style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}>
                                                    {DIAS_SEMANA.map((d) => (
                                                        <MDBox key={d.value} style={{ display: "flex", alignItems: "center", marginRight: 8 }}>
                                                            <Checkbox
                                                                name={`dia${d.value}`}
                                                                checked={diasObligatorios.includes(d.value)}
                                                                onChange={() => handleToggleDia(d.value)}
                                                            />
                                                            <MDTypography variant="button" fontWeight="regular" color="text" sx={{ ml: -1 }}>
                                                                {d.label}
                                                            </MDTypography>
                                                        </MDBox>
                                                    ))}
                                                </MDBox>
                                                {diasObligatorios.length === 0 && (
                                                    <Alert severity="warning">
                                                        Sin días marcados, el usuario Mixto se comporta siempre como Voluntario.
                                                    </Alert>
                                                )}
                                            </MDBox>
                                        )}
                                        <MDBox mt={2}>
                                            <TextField
                                                type="number"
                                                name="gestionesMinimasDia"
                                                label="Gestiones mínimas por día"
                                                variant="standard"
                                                inputProps={{ min: 0 }}
                                                value={gestionesMinimasDia}
                                                onChange={(e) => setGestionesMinimasDia(e.target.value)}
                                                helperText={`Vacío o 0: usa las del perfil (${gestionesMinimasPerfil > 0 ? gestionesMinimasPerfil : "sin mínimo"}).`}
                                                fullWidth
                                            />
                                        </MDBox>
                                    </>
                                ) : (
                                    <Alert severity="info">
                                        Modalidad: <strong>{MODALIDADES.find((m) => m.value === modalidadGestion)?.label}</strong>
                                        {modalidadGestion === 2 && diasObligatorios.length > 0
                                            ? ` (obligatorio: ${DIAS_SEMANA.filter((d) => diasObligatorios.includes(d.value)).map((d) => d.label).join(", ")})`
                                            : ""}
                                        . Gestiones mínimas por día: {gestionesMinimasDia || (gestionesMinimasPerfil > 0 ? `${gestionesMinimasPerfil} (del perfil)` : "sin mínimo")}.
                                        Solo los perfiles autorizados pueden cambiar estos datos.
                                    </Alert>
                                )}
                            </MDBox>
                        )}


                        <MDBox mb={1} style={{ display: "flex", gap: "16px" }}>
                            <MDButton
                                onClick={() => {
                                    handleSubmit();
                                }}
                                variant="gradient"
                                color="warning"
                                endIcon={<Save />}
                                disabled={grabando}
                                fullWidth
                            >
                                Grabar
                            </MDButton>

                            <MDButton
                                onClick={() => {
                                    handleVolver();
                                }}
                                variant="gradient"
                                color="warning"
                                endIcon={<ExitToApp />}

                                fullWidth
                            >
                                {nombreboton}
                            </MDButton>
                        </MDBox>
                    </MDBox>
                    {mensaje !== '' && (

                        <Alert severity={exito ? "success" : "error"}>
                            <AlertTitle>{exito ? "Felicitaciones" : "Error"}</AlertTitle>
                            {mensaje}
                        </Alert>
                    )}
                </MDBox>
            </Card>
        </BasicLayout>
    );
};

export default UsuarioEdit;
